// Complete Viketory bikes database
// Data extracted from ewheel.es

export const brandInfo = {
  name: "Viketory",
  tagline: "E-Bike di Alta Qualità",
  description: "Le EBIKE VIKETORY sono biciclette elettriche di alta qualità, progettate per soddisfare le esigenze della mobilità moderna. Dotate di tecnologie avanzate, offrono la perfetta combinazione di potenza, autonomia ed efficienza, senza rinunciare allo stile.",
  manufacturer: "Progettate e prodotte dal gruppo internazionale europeo EWheel, dal 2017 sul mercato quale fornitore specializzato in componenti e ricambi per monopattini ed ebike.",
  logo: "https://ewheel.es/cdn/shop/files/Viketory-logo.png?v=2328898208951114134"
};

export const categories = [
  { id: "folding", name: "Fatbike Pieghevoli", description: "Compatte e versatili, perfette per ogni spazio", icon: "fold" },
  { id: "fatbike", name: "Fatbike", description: "Ruote extra larghe per massima stabilità su ogni terreno", icon: "mountain" },
  { id: "mtb", name: "Mountain Bike", description: "Per chi cerca avventura fuori dall'asfalto", icon: "trees" },
  { id: "urban", name: "Urbane", description: "Comfort e praticità per il commuting quotidiano", icon: "building" }
];

export const bikes = [
  // FATBIKE
  {
    id: "navy",
    slug: "navy",
    name: "Navy",
    category: "fatbike",
    tagline: "Forte, Imponente e Pronta a Tutto",
    description: "NAVY è una fatbike dallo spirito aggressivo e dal design robusto, pensata per chi cerca presenza, stabilità e stile. La sella allungata dona un look distintivo e maggiore comfort.",
    color: "Blu Navy / Bianco",
    images: [
      "/bikes/navy.png",
      "/bikes/navy-2.webp",
      "/bikes/navy-3.webp",
      "/bikes/navy-4.webp",
      "/bikes/navy-5.webp",
      "/bikes/navy-6.webp"
    ],
    specs: {
      motor: "250W XAD EW09RX - 80 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "20\" × 4.0 Fat Tire",
      brakes: "Idraulici 180mm + 180mm",
      gears: "Shimano Altus 7V",
      fork: "Ammortizzata 60mm",
      frame: "Alluminio 6061",
      weight: "40.7 kg",
      dimensions: "179 × 79 × 106 cm"
    },
    features: ["Sella allungata", "Ammortizzatore centrale", "Display LCD colori", "A norma stradale"],
    pricing: { list: 2099, promo: null, launch: 1590 },
    purchaseLink: "https://www.freewheel.store/products/Navy-p823774011",
    motorType: "posteriore",
    highlight: true
  },
  {
    id: "commando",
    slug: "commando",
    name: "Commando",
    category: "fatbike",
    tagline: "Spirito Aggressivo, Design Robusto",
    description: "COMMANDO è una fatbike di spirito aggressivo e design robusto, pensata per chi cerca presenza, stabilità e stile. Ruote extra larghe e costruzione solida per ogni superficie.",
    color: "Giallo / Bianco - Rosso",
    colorVariants: [
      {
        id: "giallo-bianco",
        color: "Giallo / Bianco",
        images: [
          "/bikes/commando-giallo-bianco.png",
          "/bikes/commando-giallo-bianco-2.webp",
          "/bikes/commando-giallo-bianco-3.webp",
          "/bikes/commando-giallo-bianco-4.webp",
          "/bikes/commando-giallo-bianco-5.webp",
          "/bikes/commando-giallo-bianco-6.webp"
        ]
      },
      {
        id: "rosso",
        color: "Rosso",
        images: [
          "/bikes/commando-rosso.png",
          "/bikes/commando-rosso-2.webp",
          "/bikes/commando-rosso-3.webp",
          "/bikes/commando-rosso-4.webp",
          "/bikes/commando-rosso-5.webp",
          "/bikes/commando-rosso-6.webp"
        ]
      }
    ],
    images: [
      "/bikes/commando-giallo-bianco.png",
      "/bikes/commando-giallo-bianco-2.webp",
      "/bikes/commando-giallo-bianco-3.webp",
      "/bikes/commando-giallo-bianco-4.webp",
      "/bikes/commando-giallo-bianco-5.webp",
      "/bikes/commando-giallo-bianco-6.webp"
    ],
    specs: {
      motor: "250W XAD EW09RX - 80 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "20\" × 4.0 Fat Tire",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano Altus 7V",
      fork: "TOP TRAMA 60mm",
      frame: "Alluminio 6061",
      weight: "42.4 kg",
      dimensions: "179 × 79 × 106 cm"
    },
    features: ["Sella customizzata", "Ammortizzatore centrale", "Display LCD colori", "Catena KMC 7V"],
    pricing: { list: 1999, promo: null, launch: 1495 },
    purchaseLink: "https://www.freewheel.store/products/Commando-p823773554",
    motorType: "posteriore",
    highlight: false
  },

  // MTB
  {
    id: "terram",
    slug: "terram",
    name: "Terram",
    category: "mtb",
    tagline: "Performance al Top",
    description: "La TERRAM è una e-MTB pensata per chi vuole andare oltre l'uso urbano, combinando comodità, controllo e capacità di affrontare camini e piste. Componenti premium RockShox e SRAM.",
    color: "Grigio / Bianco",
    images: [
      "/bikes/TERRAM.png",
      "/bikes/terram-2.webp",
      "/bikes/terram-3.webp",
      "/bikes/terram-4.webp",
      "/bikes/terram-5.webp",
      "/bikes/terram-6.webp"
    ],
    specs: {
      motor: "250W BAFANG M560 Centrale - 130 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "29\" MAXXIS MINION DHF",
      brakes: "Idraulici 4 pistoni 203mm",
      gears: "SRAM NX 11V",
      fork: "RockShox PSYLO GOLD 160mm",
      frame: "Alluminio 6061",
      weight: "34 kg",
      dimensions: "201 × 78 × 110 cm"
    },
    features: ["Ammortizzatore RockShox DELUXE", "Tija telescopica 150mm", "Sella SELLE ROYAL", "Motore centrale"],
    pricing: { list: 3999, promo: null, launch: 3499 },
    purchaseLink: "https://www.freewheel.store/products/Terram-p824124954",
    motorType: "centrale",
    highlight: true
  },
  {
    id: "roktar",
    slug: "roktar",
    name: "Roktar",
    category: "mtb",
    tagline: "MTB Polivalente",
    description: "La ROKTAR è una e-MTB per utenti che cercano un'esperienza polivalente fuori dall'asfalto. Equilibrata e accessibile per godere della montagna senza complicazioni.",
    color: "Rosso/Nero - Nero/Arancio",
    images: [
      "/bikes/roktar.png",
      "/bikes/roktar-2.webp",
      "/bikes/roktar-3.webp",
      "/bikes/roktar-4.webp",
      "/bikes/roktar-5.webp",
      "/bikes/roktar-6.webp"
    ],
    specs: {
      motor: "250W XAD EW07RX - 42 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "29\" MAXXIS RECON",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano M360 8V",
      fork: "TOP TRAMA 160mm",
      frame: "Alluminio 6061",
      weight: "32.9 kg",
      dimensions: "196 × 77 × 110 cm"
    },
    features: ["Display LCD colori", "Sella confortevole", "Catena KMC 8V", "Forcella 160mm"],
    pricing: { list: 1999, promo: null, launch: 1799 },
    purchaseLink: "https://www.freewheel.store/products/Roktar-p826886774",
    motorType: "posteriore",
    highlight: false
  },
  {
    id: "roktar-plus",
    slug: "roktar-plus",
    name: "Roktar Plus",
    category: "mtb",
    tagline: "MTB Polivalente Potenziata",
    description: "La ROKTAR Plus è la versione potenziata della e-MTB Roktar. Motore da 80 Nm per affrontare salite impegnative e sentieri tecnici con maggiore facilità.",
    color: "Rosso/Nero - Nero/Arancio",
    images: [
      "/bikes/roktar-plus.png",
      "/bikes/roktar-plus-2.webp",
      "/bikes/roktar-plus-3.webp",
      "/bikes/roktar-plus-4.webp",
      "/bikes/roktar-plus-5.webp",
      "/bikes/roktar-plus-6.webp"
    ],
    specs: {
      motor: "250W XAD EW09RX - 80 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "29\" MAXXIS RECON",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano M360 8V",
      fork: "TOP TRAMA 160mm",
      frame: "Alluminio 6061",
      weight: "33.5 kg",
      dimensions: "196 × 77 × 110 cm"
    },
    features: ["Motore potenziato 80 Nm", "Display LCD colori", "Sella confortevole", "Forcella 160mm"],
    pricing: { list: 2999, promo: null, launch: 2499 },
    purchaseLink: "https://www.freewheel.store/products/Roktar-Plus-p826886067",
    motorType: "centrale",
    highlight: false
  },
  {
    id: "zhepir",
    slug: "zhepir",
    name: "Zhepir",
    category: "mtb",
    tagline: "Versatilità Totale",
    description: "La ZHEPIR è pensata per chi cerca un'esperienza polivalente tra sentieri tranquilli, piste di terra e uso ricreativo. Conducione comoda, stabile e facile da controllare.",
    color: "Verde Militar - Blu",
    images: [
      "/bikes/zhepir.png",
      "/bikes/zhepir-2.webp",
      "/bikes/zhepir-3.webp",
      "/bikes/zhepir-4.webp",
      "/bikes/zhepir-5.webp",
      "/bikes/zhepir-6.webp"
    ],
    specs: {
      motor: "250W XAD EW07RX - 42 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "29\" × 2.4 MAXXIS RECON",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano M360 8V",
      fork: "EXSHO 140mm",
      frame: "Alluminio 6061",
      weight: "33 kg",
      dimensions: "196 × 77 × 110 cm"
    },
    features: ["Display LCD colori", "Sella confortevole", "Forcella EXSHO", "2 colori disponibili"],
    pricing: { list: 1999, promo: null, launch: 1799 },
    purchaseLink: "https://www.freewheel.store/products/Zhepir-p826887013",
    motorType: "posteriore",
    highlight: false
  },
  {
    id: "zhepir-plus",
    slug: "zhepir-plus",
    name: "Zhepir X+Plus",
    category: "mtb",
    tagline: "Versatilità Totale Potenziata",
    description: "La ZHEPIR X+Plus è la versione potenziata della MTB Zhepir. Motore da 80 Nm per affrontare qualsiasi terreno con potenza superiore.",
    color: "Blu - Verde Militar",
    images: [
      "/bikes/zhepir-plus.png",
      "/bikes/zhepir-plus-2.webp",
      "/bikes/zhepir-plus-3.webp",
      "/bikes/zhepir-plus-4.webp",
      "/bikes/zhepir-plus-5.webp",
      "/bikes/zhepir-plus-6.webp"
    ],
    specs: {
      motor: "250W XAD EW09RX - 80 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "29\" × 2.4 MAXXIS RECON",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano M360 8V",
      fork: "EXSHO 140mm",
      frame: "Alluminio 6061",
      weight: "33.5 kg",
      dimensions: "196 × 77 × 110 cm"
    },
    features: ["Motore potenziato 80 Nm", "Display LCD colori", "Sella confortevole", "2 colori disponibili"],
    pricing: { list: 2999, promo: null, launch: 2499 },
    purchaseLink: "https://www.freewheel.store/products/Zhepir-Plus-p826886775",
    motorType: "centrale",
    highlight: false
  },

  // URBAN
  {
    id: "arenox",
    slug: "arenox",
    name: "Arenox",
    category: "urban",
    tagline: "Eleganza Urbana",
    description: "ARENOX è una ebike urbana che priorizza la comodità, facilità d'uso e conducione stabile in ambienti urbani. Perfetta per il commuting quotidiano.",
    color: "Perlato - Rame",
    images: [
      "/bikes/arenox.png",
      "/bikes/arenox-2.webp",
      "/bikes/arenox-3.webp",
      "/bikes/arenox-4.webp",
      "/bikes/arenox-5.webp",
      "/bikes/arenox-6.webp"
    ],
    specs: {
      motor: "250W XAD EW07RX - 42 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "27.5\" × 1.95",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano ACERA 7V",
      fork: "TOP TRAMA 120mm",
      frame: "Alluminio 6061",
      weight: "33.7 kg",
      dimensions: "181 × 73 × 110 cm"
    },
    features: ["Design elegante", "Sella confortevole", "2 colori disponibili", "Display LCD colori"],
    pricing: { list: 1999, promo: null, launch: 1799 },
    purchaseLink: "https://www.freewheel.store/products/Arenox-p826887010",
    motorType: "posteriore",
    highlight: false
  },
  {
    id: "arenox-plus",
    slug: "arenox-plus",
    name: "Arenox X+Plus",
    category: "urban",
    tagline: "Eleganza Urbana Potenziata",
    description: "ARENOX X+Plus è la versione potenziata della ebike urbana Arenox. Maggiore coppia e prestazioni superiori per chi cerca il massimo comfort in città.",
    color: "Rame - Perlato",
    images: [
      "/bikes/arenox-plus.png",
      "/bikes/arenox-plus-2.webp",
      "/bikes/arenox-plus-3.webp",
      "/bikes/arenox-plus-4.webp",
      "/bikes/arenox-plus-5.webp",
      "/bikes/arenox-plus-6.webp"
    ],
    specs: {
      motor: "250W XAD EW09RX - 80 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "27.5\" × 1.95",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano ACERA 7V",
      fork: "TOP TRAMA 120mm",
      frame: "Alluminio 6061",
      weight: "34 kg",
      dimensions: "181 × 73 × 110 cm"
    },
    features: ["Motore potenziato 80 Nm", "Design elegante", "Sella confortevole", "Display LCD colori"],
    pricing: { list: 2999, promo: null, launch: 2499 },
    purchaseLink: "https://www.freewheel.store/products/Arenox-Plus-p826886773",
    motorType: "centrale",
    highlight: false
  },
  {
    id: "ventix",
    slug: "ventix",
    name: "Ventix",
    category: "urban",
    tagline: "Comfort Quotidiano",
    description: "La VENTIX è una ebike urbana pensata per il giorno a giorno, progettata per spostamenti comodi, pratici ed efficienti in città.",
    color: "Grigio/Rosso - Grigio/Blu",
    images: [
      "/bikes/ventix.png",
      "/bikes/ventix-2.webp",
      "/bikes/ventix-3.webp",
      "/bikes/ventix-4.webp",
      "/bikes/ventix-5.webp",
      "/bikes/ventix-6.webp"
    ],
    specs: {
      motor: "250W XAD EW07RX - 42 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "27.5\" × 1.95",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano ACERA 7V",
      fork: "TOP TRAMA 120mm",
      frame: "Alluminio 6061",
      weight: "33.35 kg",
      dimensions: "181 × 73 × 110 cm"
    },
    features: ["Posizione eretta", "Sella confortevole", "2 colori disponibili", "Display LCD colori"],
    pricing: { list: 1999, promo: null, launch: 1799 },
    purchaseLink: "https://www.freewheel.store/products/Ventix-p826886068",
    motorType: "posteriore",
    highlight: false
  },
  {
    id: "ventix-plus",
    slug: "ventix-plus",
    name: "Ventix X+Plus",
    category: "urban",
    tagline: "Comfort Quotidiano Potenziato",
    description: "La VENTIX X+Plus è la versione potenziata della ebike urbana Ventix. Maggiore coppia per affrontare salite e tragitti impegnativi con facilità.",
    color: "Grigio/Blu - Grigio/Rosso",
    images: [
      "/bikes/ventix-plus.png",
      "/bikes/ventix-plus-2.webp",
      "/bikes/ventix-plus-3.webp",
      "/bikes/ventix-plus-4.webp",
      "/bikes/ventix-plus-5.webp",
      "/bikes/ventix-plus-6.webp"
    ],
    specs: {
      motor: "250W XAD EW09RX - 80 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "27.5\" × 1.95",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano ACERA 7V",
      fork: "TOP TRAMA 120mm",
      frame: "Alluminio 6061",
      weight: "33.5 kg",
      dimensions: "181 × 73 × 110 cm"
    },
    features: ["Motore potenziato 80 Nm", "Posizione eretta", "Sella confortevole", "Display LCD colori"],
    pricing: { list: 2999, promo: null, launch: 2499 },
    purchaseLink: "https://www.freewheel.store/products/Ventix-Plus-p826887012",
    motorType: "centrale",
    highlight: false
  },

  // FOLDING
  {
    id: "granit",
    slug: "granit",
    name: "Granit",
    category: "folding",
    tagline: "Fatbike Pieghevole",
    description: "GRANIT è una fatbike pieghevole progettata per offrire massima comodità senza rinunciare alla forza. Telaio aperto per salire e scendere facilmente.",
    color: "Bianca",
    images: [
      "/bikes/granit.png",
      "/bikes/granit-2.webp",
      "/bikes/granit-3.webp",
      "/bikes/granit-4.webp",
      "/bikes/granit-5.webp",
      "/bikes/granit-6.webp"
    ],
    specs: {
      motor: "250W XAD EW09RX - 80 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "20\" × 4.0 Fat Tire",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano Altus 7V",
      fork: "TOP TRAMA 60mm",
      frame: "Alluminio 6061 Pieghevole",
      weight: "37.85 kg",
      dimensions: "178 × 63 × 133 cm"
    },
    features: ["Telaio aperto", "Sistema piegatura rapido", "Sella confortevole", "Fat Tire 20×4"],
    pricing: { list: 1490, promo: null, launch: 1190 },
    purchaseLink: "https://www.freewheel.store/products/Granit-p826887011",
    motorType: "posteriore",
    highlight: false
  },
  {
    id: "lithor",
    slug: "lithor",
    name: "Lithor",
    category: "folding",
    tagline: "Forza e Praticità",
    description: "LITHOR è una fatbike pieghevole che combina forza, comodità e funzionalità. Domina terreni irregolari come sabbia, neve o sterrato con facilità.",
    color: "Crema - Grigio - Turchese",
    colorVariants: [
      {
        id: "crema",
        color: "Crema",
        images: [
          "/bikes/lithor-crema.png",
          "/bikes/lithor-crema-2.webp",
          "/bikes/lithor-crema-3.webp",
          "/bikes/lithor-crema-4.webp",
          "/bikes/lithor-crema-5.webp",
          "/bikes/lithor-crema-6.webp"
        ]
      },
      {
        id: "grigio",
        color: "Grigio",
        images: [
          "/bikes/lithor-grigio.png",
          "/bikes/lithor-grigio-2.webp",
          "/bikes/lithor-grigio-3.webp",
          "/bikes/lithor-grigio-4.webp",
          "/bikes/lithor-grigio-5.webp",
          "/bikes/lithor-grigio-6.webp"
        ]
      },
      {
        id: "turchese",
        color: "Turchese",
        images: [
          "/bikes/lithor-turchese.png",
          "/bikes/lithor-turchese-2.webp",
          "/bikes/lithor-turchese-3.webp",
          "/bikes/lithor-turchese-4.webp",
          "/bikes/lithor-turchese-5.webp",
          "/bikes/lithor-turchese-6.webp"
        ]
      }
    ],
    images: [
      "/bikes/lithor-crema.png",
      "/bikes/lithor-crema-2.webp",
      "/bikes/lithor-crema-3.webp",
      "/bikes/lithor-crema-4.webp",
      "/bikes/lithor-crema-5.webp",
      "/bikes/lithor-crema-6.webp"
    ],
    specs: {
      motor: "250W XAD EW09RX - 80 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "20\" × 4.0 Fat Tire",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano Altus 7V",
      fork: "TOP TRAMA 60mm",
      frame: "Alluminio 6061 Pieghevole",
      weight: "40.1 kg",
      dimensions: "178 × 64 × 134 cm"
    },
    features: ["Sistema piegatura rapido", "Sella confortevole", "Fat Tire 20×4", "Design retrò"],
    pricing: { list: 1490, promo: null, launch: 1190 },
    purchaseLink: "https://www.freewheel.store/products/Lithor-p823774517",
    motorType: "posteriore",
    highlight: false
  },
  {
    id: "brave",
    slug: "brave",
    name: "Brave",
    category: "folding",
    tagline: "Avventura Senza Limiti",
    description: "La BRAVE è una fatbike pieghevole con sospensione che porta l'avventura a un altro livello. Comodità, potenza e libertà in un unico design.",
    color: "Arancio / Grigio",
    images: [
      "/bikes/brave.png",
      "/bikes/brave-2.webp",
      "/bikes/brave-3.webp",
      "/bikes/brave-4.webp",
      "/bikes/brave-5.webp",
      "/bikes/brave-6.webp"
    ],
    specs: {
      motor: "250W XAD EW09RX - 80 Nm",
      battery: "48V 15Ah / 720Wh",
      wheels: "20\" × 4.0 Fat Tire",
      brakes: "Idraulici GEMMA 180mm",
      gears: "Shimano Altus 7V",
      fork: "TOP TRAMA 60mm",
      frame: "Alluminio 6061 Pieghevole",
      weight: "41.1 kg",
      dimensions: "173 × 63 × 132 cm"
    },
    features: ["Ammortizzatore centrale", "Sistema piegatura", "Sella confortevole", "Full suspension"],
    pricing: { list: 1590, promo: null, launch: 1290 },
    purchaseLink: "https://www.freewheel.store/products/Brave-p823758477",
    motorType: "posteriore",
    highlight: true
  }
];

// Contact info FreeWheel
export const contactInfo = {
  shopName: "FreeWheel Store",
  email: "info@freewheel.store",
  phone: "+39 081 314 94 11",
  whatsapp: "https://wa.me/390813149411",
  address: "Via Salvador Allende, 33, 80053, Castellammare di Stabia (NA)",
  hours: "Lun-Sab 9:00-19:30",
  website: "https://www.freewheel.store",
  appointmentLink: "https://calendly.com/freewheelstabia/expert",
  social: {
    facebook: "https://www.facebook.com/FreeWheelStore",
    instagram: "https://www.instagram.com/freewheelstore",
    youtube: "https://www.youtube.com/@freewheel_store",
    tiktok: "https://www.tiktok.com/@freewheelstore"
  }
};

export const getBikeBySlug = (slug) => bikes.find(b => b.slug === slug);

export const getBikeGalleryImages = (bike, colorVariantId) => {
  if (!bike) return [];
  if (bike.colorVariants?.length) {
    const variant =
      bike.colorVariants.find((v) => v.id === colorVariantId) || bike.colorVariants[0];
    return variant.images;
  }
  return bike.images;
};
export const getBikesByCategory = (category) => bikes.filter(b => b.category === category);
export const getHighlightedBikes = () => bikes.filter(b => b.highlight);

export default { brandInfo, categories, bikes, contactInfo };
